import React from 'react';
import {injectIntl} from 'react-intl';
import {constants} from '@neosvoc/nv-platform-core-common';
import messages from '../../../../res/translations/messages';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

const buildOptions = (config, data, hints, intl) => {
    config = Object.assign({title: intl.formatMessage(messages.chart.title.channels)}, config);
    return fillChartOptions({
        chart: {
            spacingBottom: 0,
        },
        legend: {enabled: false},
        tooltip: {
            pointFormat: hints.absolute ? '{point.y:f}' : '{point.percentage:.1f}%',
        },
        plotOptions: {
            pie: {
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '100%'],
                size: '160%',
            },
        },
        series: [{
            type: 'pie',
            innerSize: '50%',
            data: Object.values(constants.CHANNEL_TYPES).filter((c) => data.values[c] > 0).map((c) => ({
                name: intl.formatMessage(messages.channels[c]),
                y: data.values[c] || 0,
            })),
        }],
    }, config, data, hints, intl);
};

const ChannelStatsWidget = ({intl, data, hints, params}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} />
);

export default injectIntl(ChannelStatsWidget);
